<template>
  <v-snackbar v-model="visible" :timeout="-1" color="warning" top translate="no" class="notranslate">
    <div class="d-flex align-center clickable" @click="hideWarning">
      <div class="flex-grow-1">
        {{$t('appTranslationWarning.warning')}}
      </div>
      <div class="mx-1">
        <v-icon small>fa-times</v-icon>
      </div>
    </div>
  </v-snackbar>
</template>

<script>
import { logger } from '@/helpers/log.service';
export default {
  name: 'AppTranslationWarning',
  data() {
    return {
      observer: null,
      visible: false
    };
  },
  mounted() {
    this.trackPageTranslation();
  },
  destroyed() {
    this.observer.disconnect();
  },
  methods: {
    hideWarning() {
      this.visible = false;
    },
    trackPageTranslation() {
      logger.debug(
        `[AppTranslationWarning:trackPageTranslation] beginning observe page translation`
      );
      this.observer = new MutationObserver((e) => {
        if (document.documentElement.className.match('translated')) {
          logger.debug(`[AppTranslationWarning] page translation enabled`);
          this.visible = true;
        } else {
          logger.debug(`[AppTranslationWarning] page translation disabled`);
          this.visible = false;
        }
      });

      this.observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class'],
        childList: false,
        characterData: false
      });
    }
  }
};
</script>
